export default __webpack_public_path__ + "static/media/drawing-man8-focusfill.9f4ba9a5.svg";